import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';

import { CurrentUserService } from '../services/current-user/current-user.service';

/**
 * This function checks if the user has all the required claims to access the route.
 * If the user does not have all the required claims, it redirects the user to the forbidden page.
 */
export const ClaimsGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot
) => {
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);

  const requiredClaims = route.data?.['claims'] as string[] | string;
  const claimsArray =
    typeof requiredClaims === 'string'
      ? [requiredClaims]
      : requiredClaims || [];

  if (!currentUserService.currentUser) {
    const forbiddenPath = router.parseUrl('dashboard/forbidden');
    return new RedirectCommand(forbiddenPath, {
      skipLocationChange: true,
    });
  }

  const userClaims = currentUserService.currentUser.claims.map(c => c.name);
  const hasAllClaims = claimsArray.every(c => userClaims.includes(c));

  if (!hasAllClaims) {
    const forbiddenPath = router.parseUrl('dashboard/forbidden');
    return new RedirectCommand(forbiddenPath, {
      skipLocationChange: true,
    });
  }
  return true;
};
